import { render, staticRenderFns } from "./AttachmentResolver.vue?vue&type=template&id=079e3a82&scoped=true&"
import script from "./AttachmentResolver.vue?vue&type=script&lang=js&"
export * from "./AttachmentResolver.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentResolver.vue?vue&type=style&index=0&id=079e3a82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079e3a82",
  null
  
)

export default component.exports